<template>
	<div class="reportList">
	    <div class="o-main-content-area">
	        <div class="o-page-top-heading c-responsive-fixwidth">
	            <div class="row">
	                <div class="col-md-9">
	                    <h1 class="h1">Reports:</h1>
	                </div>
	                 <div class="col-md-3">
	                    <div class="input-group stylish-input-group" style="display:none">
	                        <input v-on:input="onSearchReports" v-model="searchInputdata" type="text" class="form-control" placeholder="Search">
	                        <span class="input-group-addon">
	                        <button type="submit">
	                            <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
	                        </button>
	                        </span>
	                    </div>
	                </div> 
	            </div>
	        </div>

            <div v-loading="reportLoading" class="o-ndividualArea c-responsive-fixwidth">
                <div class="o-individual-calls clearfix o-overflow-visible">
	                <div class="o-no-padding c-common-space c-common-box-shadow c-radius3">
	                    <div class="form-inline c-user-tab-content u-padding-20 col-md-12 col-sm-12">
                            <div v-for="(item, key) in reportList" :key="key"> 
                                <div class="col-md-2 col-sm-12">
	                                <button :disabled="reportLoading" @click="openQueryPopup(item)" 
                                        class="c-common-btn c-common-btn--green margin-5"> 
                                        {{item.label ? item.label:'Report'}}
                                    </button>
                                </div>
                            </div>
	                    </div>
	                </div>
                </div>
            </div>
	    </div>

        <modal name="report-filter-oppup" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
		    <div tabindex="-1" role="dialog">
		        <div role="document">
		            <div v-loading="loadingModal" class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center modal-header--heading">
		                    <button @click="closeModal('report-filter-oppup')" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
		                    <h1 class="modal-title">Select Query</h1>
		                </div>
		                <div v-if="selectFilter!='call_action'" class="modal-body c-common-box-shadow o-modal-body">

		                    <div class="row">
                                <div v-if="selectedReport && selectedReport.type=='hourly'" class="col-md-3">
                                    <label for="exampleInputEmail3" class="common-label-text">Variables:</label>
                                </div>
                                <div v-if="selectedReport && selectedReport.type=='hourly'" class="col-md-9 col-sm-9 form-group">
                                    <div class="o-cutsomSelect o-display-inline">
                                        <select v-model="selectFilter" @change="popupListEnabled=false" class="form-control fix-width-input">
                                            <option value="monthly">Monthly job report</option>
                                            <option value="yearly">Yearly job report</option>
                                            <option value="custom">Custom job report</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectFilter" class="col-md-3">
                                    <span class="common-label-text">Report for:</span>
                                </div>
                                <div v-if="selectFilter=='monthly'" class="col-sm-9 skillset">
                                    <el-date-picker
                                        v-model="selectdate"
                                        class="o-inline-datepicker-icon"
                                        type="month"
                                        format="MMMM yyyy"
                                        @change="popupListEnabled=false"
                                        placeholder="">
                                    </el-date-picker>
                                </div>
                                <div v-if="selectFilter=='daily_schedule'" class="col-sm-9 skillset">
                                    <el-date-picker
                                        v-model="dailyReportDate"
                                        class="o-inline-datepicker-icon"
                                        type="date"
                                        format="dd MMMM yyyy"
                                        value-format="yyyy-MM-dd"
                                        @change="popupListEnabled=false"
                                        placeholder="">
                                    </el-date-picker>
                                </div>
                                <div v-if="selectFilter=='yearly' || selectFilter=='call_action'" class="col-sm-9 skillset">
                                    <el-date-picker
                                        v-model="selectdate"
                                        class="o-inline-datepicker-icon"
                                        type="year"
                                        format="yyyy"
                                        @change="popupListEnabled=false"
                                        placeholder="">
                                    </el-date-picker>
                                </div>
                                <div v-if="selectFilter=='custom'" class="col-sm-9 skillset">
                                    <el-date-picker
                                        v-model="customStart"
                                        class="o-inline-datepicker-icon"
                                        type="date"
                                        format="dd MMM yyyy"
                                        @change="popupListEnabled=false"
                                        placeholder="">
                                    </el-date-picker>
                                    <span class="common-label-text">to</span>
                                    <el-date-picker
                                        v-model="customEnd"
                                        class="o-inline-datepicker-icon"
                                        type="date"
                                        format="dd MMM yyyy"
                                        @change="popupListEnabled=false"
                                        placeholder="">
                                    </el-date-picker>
                                </div>
		                    </div>
		                </div>

		                <div class="modal-footer text-center">
		                    <ul v-if="selectFilter!='yearly' && selectFilter!='call_action'" class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="closeModal('report-filter-oppup')" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        <li>
		                            <a @click="openReport()" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-eye" aria-hidden="true"></i> Open</a>
		                        </li>
		                    </ul>
                            <ul v-if="selectFilter=='yearly'" class="o-filter-area">
		                        <li>
		                            <a @click="getJulyJune()" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-eye" aria-hidden="true"></i> July to June</a>
		                        </li>
                                <li>
		                            <a @click="getJanDec()" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-eye" aria-hidden="true"></i> January to December</a>
		                        </li>
		                    </ul>
                            <ul v-if="selectFilter=='call_action'" class="o-filter-area">
		                        <li>
		                            <a @click="callActionRepotType(1)" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-eye" aria-hidden="true"></i> Current Year</a>
		                        </li>
                                <li>
		                            <a @click="callActionRepotType(0)" href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-eye" aria-hidden="true"></i> Previous Year</a>
		                        </li>
		                    </ul>
		                </div>
		            </div>
		        </div>
		    </div>
		</modal>
    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    import { generateReportAsync } from '../../reportTaskPoller';
    export default {
        data() {
            return {
                reportLoading: false,
                reportList: [],
                storeMore: [],
                selectFilter: 'yearly',
                next_page: '',
                selectdate: new Date(),
                totalReports: 0,
                totalCalls: 0,
                loading: false,
                loadingModal: false,
                afterAPI: false,
                searchInputdata: '',
                customStart: new Date(),
                customEnd: new Date(),
                popupListEnabled: false,
                selectedReport: null,
                isCurrentYear: 1,
                dailyReportDate: moment().format('YYYY-MM-DD')
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                employeeId: "employeeId",
                getSubdomain: 'getSubdomain'
            })
        },
        methods: {

            closeModal(id){
                this.$modal.hide(id);
            },
            openModal(id){
                this.$modal.show(id);
            },
            openQueryPopup(report){
                this.selectedReport = report;
                if(report.type == 'hourly'){
                    this.selectFilter = "custom";
                    this.openModal('report-filter-oppup');
                }else if(report.type == 'employee'){
                    this.selectFilter = report.type;
                    this.openReport();
                }else if(report.type == 'daily_schedule') {
                    this.selectFilter = report.type;
                    this.openModal('report-filter-oppup');
                }else if(report.type == 'null'){
                    this.selectFilter = report.type;
                    this.openReport();
                }else{
                    this.selectFilter = report.type;
                    this.openModal('report-filter-oppup');
                }
            },
            callActionRepotType(type){
                this.isCurrentYear = type;
                this.openReport();
            },
            getJulyJune(){
                let currentYear = moment(this.selectdate).year();
                this.customStart = currentYear+"-07-01";
                this.customEnd = (Number(currentYear)+1)+"-06-30";
                this.getCustomYear();
            },
            getJanDec(){
                let currentYear = moment(this.selectdate).year();
                this.customStart = currentYear+"-01-01";
                this.customEnd = currentYear+"-12-31";
                this.getCustomYear();
            },
            async getCustomYear(){
                this.loadingModal = true;
                try {
                    const task = await generateReportAsync('active_report', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }, {
                        report_id: this.selectedReport.id,
                        type: 'custom',
                        month: '',
                        year: '',
                        start: this.customStart,
                        end: this.customEnd,
                        hourlyRepot: 0,
                    });
                    this.loadingModal = false;
                    if(task.result_meta && task.result_meta.active_report && task.result_meta.active_report.rdlx_template){
                        let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', task.result_meta.active_report.rdlx_template, task.gcs_path);
                        window.open(redirectUrl, "_blank");
                    }else{
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Report template not found.',
                            type: 'error'
                        });
                    }
                    if(!task.gcs_path){
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Report Data Source not found.',
                            type: 'error'
                        });
                    }
                    this.closeModal('report-filter-oppup');
                } catch (err) {
                    this.loadingModal = false;
                    this.$notify.error({ title: 'Error', message: err.message || 'Failed to generate report' });
                }
            },
            async openReport() {
                let params = {
                    report_id: this.selectedReport.id,
                    hourlyRepot: 0,
                    type: '',
                    month: '',
                    year: '',
                    start: '',
                    end: '',
                };
                switch(this.selectFilter){
                    case 'yearly':
                        params.type = 'year';
                        params.year = moment(this.selectdate).year();
                        break;
                    case 'monthly':
                        params.type = 'month';
                        params.month = moment(this.selectdate).month() + 1;
                        params.year = moment(this.selectdate).year();
                        break;
                    case 'custom':
                        params.type = 'custom';
                        params.start = moment(this.customStart).format('YYYY-MM-DD');
                        params.end = moment(this.customEnd).format('YYYY-MM-DD');
                        break;
                    case 'employee':
                        this.reportLoading = true;
                        params.type = 'employee';
                        break;
                    case 'call_action':
                        params.type = 'call_action';
                        params.isCurrentYear = this.isCurrentYear;
                        break;
                    case 'daily_schedule':
                        params.type = 'daily_schedule';
                        params.dates = this.dailyReportDate;
                        params.hourlyRepot = 0;
                        delete params.month;
                        delete params.year;
                        delete params.start;
                        delete params.end;
                        break;
                    case 'null':
                        this.reportLoading = true;
                        params.hourlyRepot = 1;
                        break;
                    default:
                }
                this.loadingModal = true;
                try {
                    const task = await generateReportAsync('active_report', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }, params);
                    this.loadingModal = false;
                    this.reportLoading = false;
                    if(task.result_meta && task.result_meta.active_report && task.result_meta.active_report.rdlx_template){
                        if(task.gcs_path){
                            let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', task.result_meta.active_report.rdlx_template, task.gcs_path);
                            window.open(redirectUrl, "_blank");
                        }else{
                            this.$notify({
                                title: this.$t('error'),
                                message: 'Report Data Source not found.',
                                type: 'error'
                            });
                        }
                    }else{
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Report template not found.',
                            type: 'error'
                        });
                    }
                    this.buttonLoading = false;
                    this.closeModal('report-filter-oppup');
                } catch (err) {
                    this.loadingModal = false;
                    this.$notify.error({ title: 'Error', message: err.message || 'Failed to generate report' });
                }
            },
            onSearchReports() {
                if (this.searchInputdata.length > 0) {
                    let month = new Date(this.selectdate).getMonth() + 1;
                    let year = new Date(this.selectdate).getFullYear();
                    service.get('job/jobSearch', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobSearch': this.searchInputdata,
                        'month': month,
                        'year': year,
                    })
                    .then((res) => {
                        this.reportList = res.data.result;
                        this.totalReports = this.reportList.length;
                        this.next_page = '';
                        this.storeMore = [];
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.getAllReportsByYear();
                }

            },
            async getReportList(){
                await service.get('superadmin/getAllRoleBasedActiveReports', {
                    'Authorization': this.userToken,
                    'userId': this.userID,
                    'employeeId': this.employeeId,
                    'role_id': this.userRole
                }).then((res) => {
                    this.reportList = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },
        },

        async created() {
            await this.getReportList();
        }
    }
</script>
